import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getAllFn = ({ page = 1, size = 10, sort = '', order = '', filters, query }) => restHelpers.withBearer.get(`${K.API_URL}/route-tasks?page=${page - 1}&size=${size}${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}${filters ? `&${filters}` : ''}${query ? `&q=${query}` : ''}`, { });
const createRoutesTaskFn = ( name, position, date, note, positionDetails) => restHelpers.withBearer.post(`${K.API_URL}/route-tasks`, { data: {  name, position, date, note, positionDetails } });
const editRoutesTaskFn = ( id, name, position, date, note, positionDetails) => restHelpers.withBearer.put(`${K.API_URL}/route-tasks/${id}`, { data: {  name, position, date, note, positionDetails } });
const deleteRoutesTaskFn = id => restHelpers.withBearer.delete(`${K.API_URL}/route-tasks/${id}`, { });
const assignRoutesTaskFn = (id, body) => restHelpers.withBearer.put(`${K.API_URL}/route-tasks/${id}/assign-driver`, { data: body });
const unassignRoutesTaskFn = id => restHelpers.withBearer.put(`${K.API_URL}/route-tasks/${id}/unassign-driver`, { data: {} });

export default {
  getAll: getAllFn,
  createRoutesTask: createRoutesTaskFn,
  editRoutesTask: editRoutesTaskFn,
  deleteRoutesTask: deleteRoutesTaskFn,
  assignRoutesTask: assignRoutesTaskFn,
  unassignRoutesTask: unassignRoutesTaskFn,
};



// WEBPACK FOOTER //
// ./src/services/routeTasks.js